export const API_BASE = process.env.COMPENSATION_API;
export const CONFIGURATION_API_PATH = 'configuration';
export const VARIANT_PAYMENTS_API_PATH = 'variant-payments';
